<div class="alert alert-danger mt-4" role="alert" *ngIf="errorMessage !== ''">
  {{ errorMessage }}
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div *ngIf="(errorMessage === '') && (serverError === null)">
  <nav class="navbar navbar-expand navbar-light bg-light capitan-sub-nav">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a [routerLink]="'/payment-processor-connections/configure/' + connId.toString()"
           class="nav-link arrow-link">&#8592;</a>
      </li>
    </ul>

    <ul class="navbar-nav mx-auto">
      <!-- No internal navigation (yet) for payment processor connections -->
    </ul>
  </nav>

  <div class="capitan-sub-nav-post-content">
    <div class="pt-3 pl-md-4"
         style="margin-bottom: 300px;">
      <h2>
        Payment Terminal Configuration
        <span *ngIf="loadingInit()" class="text-secondary">- Loading...</span>
      </h2>

      <ng-container *ngIf="!loadingInit()">

        <p class="text-secondary">
          Configure the connected payment terminals for your location using the payment processor connection {{ conn.name }}.
        </p>

        <div class="form-group">
          <select class="custom-select col-xl-4 col-lg-6 col-md-8"
                  id="selectLocation" name="selectLocation"
                  [(ngModel)]="selectedLocation"
                  [disabled]="loadingSelectLocation || (locations.length === 0)"
                  [class.disabled]="loadingSelectLocation || (locations.length === 0)">
            <option *ngFor="let location of locations"
                    [ngValue]="location">
              {{ location.name }}
            </option>
            <option *ngIf="locations.length === 0"
                    [ngValue]="null" disabled>
              No assigned locations
            </option>
          </select>
        </div>

        <div class="row">
          <div class="col-xl-6 col-lg-8">

            <div class="alert" role="alert"
                 [class.alert-success]="modalResult.status === CallbackResultStatus.success"
                 *ngIf="modalResult !== null">
              {{ modalResult.text }}
            </div>

            <div class="rounded-table-wrapper">
              <table class="table">

                <thead>
                  <tr>
                    <th>Label</th>
                    <th></th>
                  </tr>
                </thead>

                <tbody>

                  <ng-container *ngIf="readerResultsPresent()">
                    <tr *ngFor="let reader of getReadersForLocation()">
                      <td>{{ reader.label }}</td>
                      <td class="table-button-cell" style="white-space: nowrap">
                        <div class="float-right">
                          <button class="btn btn-outline-danger btn-sm mr-2"
                                  (click)="openRemoveReaderModal(reader)">
                            Remove
                          </button>
                          <button class="btn btn-outline-primary btn-sm"
                                  (click)="openEditReaderModal(reader)">
                            Edit
                          </button>
                        </div>
                      </td>
                    </tr>
                  </ng-container>

                  <ng-container *ngIf="!readerResultsPresent()">
                  <tr>
                    <td colspan="99">
                      {{ (selectedLocation === null) ? 'No location selected' : (loadingReaders ? 'Loading...' : 'No readers') }}
                    </td>
                  </tr>
                  </ng-container>

                  <tr *ngIf="!loadingReaders">
                    <td colspan="99" class="table-button-cell">
                      <button class="btn btn-outline-success btn-block"
                              [disabled]="!conn || !selectedLocation"
                              [class.disabled]="!conn || !selectedLocation"
                              (click)="openAddTerminalModal()">
                        Click to add
                      </button>
                    </td>
                  </tr>

                </tbody>

              </table>
            </div>
          </div>
        </div>

      </ng-container>
    </div>
  </div>

</div>
